import { Checkbox } from 'antd'
import { ColumnType } from 'antd/es/table'
import { useCallback } from 'react'
import React from 'react'

import { TableFilterDropdownContainer } from '../components/TableFilterDropdownContainer/TableFilterDropdownContainer'
import { columnFilterIcon } from './useColumnFilters'

/**
 *
 * client-side Ant Table columns filter by param options.
 * @param options Array of unique string options to filter by.
 * For creating this array consider using `useUniqueValues`.
 */
export function useColumnOptionFilter<T>(
  options?: string[],
  richOptions?: { text: string; value: string | number }[]
) {
  const filterOptions =
    richOptions || options?.map(opt => ({ text: opt, value: opt }))

  const getColumnOptionFilter = useCallback(
    (dataIndex: keyof T): ColumnType<T> => ({
      ...columnFilterIcon,
      filters: filterOptions,
      onFilter: (value, record) =>
        String(record?.[dataIndex])?.indexOf(value as string) === 0,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        close,
      }) => (
        <TableFilterDropdownContainer
          clearFilters={clearFilters}
          confirm={confirm}
          close={close}
          isSelected={!!selectedKeys?.length}
        >
          <div className="flex flex-col space-y-1">
            {filterOptions?.map(opt => (
              <Checkbox
                key={opt.value}
                checked={selectedKeys.includes(opt.value)}
                className="hover:bg-gray-50"
                onChange={e => {
                  const next = e.target.checked
                    ? [...selectedKeys, opt.value]
                    : selectedKeys.filter(v => v !== opt.value)
                  setSelectedKeys(next)
                }}
              >
                <div className="first-letter:uppercase">{opt.text}</div>
              </Checkbox>
            ))}
          </div>
        </TableFilterDropdownContainer>
      ),
    }),
    [filterOptions]
  )

  return { getColumnOptionFilter }
}
